import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { PropsWithChildren, useEffect, useState } from 'react';

import { msalConfig } from './msal/config';
import { MsalAuth } from './msal/MsalAuth';
import { Spinner } from '../common/components/Spinner/Spinner';

const msalInstance = new PublicClientApplication(msalConfig);

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let eventCallbackId: string | null = null;

    const initializeAuth = async () => {
      try {
        await msalInstance.initialize();

        const accounts = msalInstance.getAllAccounts();

        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }

        eventCallbackId = msalInstance.addEventCallback((event: EventMessage) => {
          if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;

            msalInstance.setActiveAccount(payload.account);
          }
        });

        setIsInitialized(true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('MSAL initialization failed:', error);
      }
    };

    initializeAuth();

    return () => {
      if (eventCallbackId) {
        msalInstance.removeEventCallback(eventCallbackId);
      }
    };
  }, []);

  if (!isInitialized) {
    return <Spinner />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuth>{children}</MsalAuth>
    </MsalProvider>
  );
};
